import { Dispatch, SetStateAction, useEffect, useState } from "react";

interface IPagination {
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
}

const CustomPagination: React.FC<IPagination> = (props) => {
  const { currentPage, setCurrentPage, totalPages } = props;
  const [pagesArr, setPagesArr] = useState<number[]>([]); // this array will have at max 9 items with the current page as center of the array

  useEffect(() => {
    generatePagesArr(currentPage, totalPages);
  }, [currentPage, totalPages]);

  const generatePagesArr = (num: number, maxNum: number) => {
    let start = Math.max(1, num - 4);
    let end = Math.min(maxNum, num + 4);

    while (end - start + 1 < 9 && (start > 1 || end < maxNum)) {
      if (start > 1) {
        start--;
      }
      if (end < maxNum) {
        end++;
      }
    }

    setPagesArr(Array.from({ length: Math.min(9, end - start + 1) }, (_, i) => start + i));
  };

  return (
    <div className="flex items-center justify-center gap-2">
      <span className={(currentPage === 1 ? "cursor-default" : "cursor-pointer") + ' text-[#D0566E] text-lg'}
        onClick={() => (currentPage > 1 ? setCurrentPage(currentPage - 1) : () => {})}> ◀ </span>
      {pagesArr.map((pageNum: number) => {
        return (
          <span
            className={(pageNum === currentPage ? 'text-white rounded-full bg-[#D0566E] cursor-default' : 'text-black cursor-pointer') + ' flex items-center justify-center text-lg h-8 w-8'}
            key={pageNum}
            onClick={() => setCurrentPage(pageNum)}
          >
            {pageNum}
          </span>
        );
      })}
      <span className={(currentPage === totalPages ? "cursor-default" : "cursor-pointer") + ' text-[#D0566E] text-lg'}
        onClick={() => (currentPage < totalPages ? setCurrentPage(currentPage + 1) : () => {})}> ▶ </span>
    </div>
  );
};

export default CustomPagination;
